import {
    AddressDTO,
    AddressType,
    AttributesValueType,
    BankDetailsDTO,
    CaseStatusType,
    CompanyDTO,
    CompanyRegistrationPeriodAttributeDTO,
    CompanyRegistrationPeriodDTO,
    CompanyRole,
    ContactInformationType,
    DocumentDescriptionDTO,
    EmailDTO,
    EmployeeTransactionAttributeDTO,
    NoteDTO,
    OfficeDTO,
    PaymentMethod,
    PersonDTO,
    PhoneNumberDTO,
    PricingOptionType,
    ProductDTO,
    ProductPricingOptionDTO,
    RestrictionDTO,
    RestrictionOperator,
    SubProductAttributeDTO,
    SubProductDTO
} from '@iota/iota-management-portal-v4-client';
import { cloneDeep } from 'lodash-es';
import { EmployeeCaseEntity, EmployeeTransactionEntity } from 'src/app/store/entity-models';
import { TransactionAttribute } from './attribute-types';
import { Currency } from './currency';
import { DEFAULT_LOCALE } from './locale';

export const DefaultWidthDocumentDialog = '1100px';
export const DefaultWidthDocumentDialogNumber = 1100;
export const DefaultHeightDocumentDialog = '621px';
export const DefaultHeightDocumentDialogNumber = 621;
export const DefaultWidthEditWithBrandingDialog = '1100px';
export const DefaultWidthEditDialog = '1000px';
export const DefaultWidthCeateDialog = '1000px';
export const DefaultWidthOtherDialog = '400px';

export const DisabledVersionDateTime = new Date('9999-12-31T00:00:00').getTime();

const DefaultAddressObject: AddressDTO = {
    addressType: AddressType.MAIN_ADDRESS,
    countryCode: 'DE'
};

export function DefaultAddress(): AddressDTO {
    return deepCopy(DefaultAddressObject);
}

const DefaultBankDetailsObject: BankDetailsDTO = {
    paymentMethod: PaymentMethod.DEBIT,
    currency: 'EUR'
};

export function DefaultBankDetails(): BankDetailsDTO {
    return deepCopy(DefaultBankDetailsObject);
}

const DefaultEmailObject: EmailDTO = {
    type: ContactInformationType.PRIVATE
};

export function DefaultEmail(): EmailDTO {
    return deepCopy(DefaultEmailObject);
}

const DefaultPhoneNumberObject: PhoneNumberDTO = {
    type: ContactInformationType.PRIVATE
};

export function DefaultPhoneNumber(): PhoneNumberDTO {
    return deepCopy(DefaultPhoneNumberObject);
}

const DefaultRestrictionObject: RestrictionDTO = {
    operator: RestrictionOperator.EQ
};

export function DefaultRestriction(): RestrictionDTO {
    return deepCopy(DefaultRestrictionObject);
}

const DefaultProductCustomizationObject: any = {
    bulletPoints: [] as string[],
    mandatory: false,
    locale: DEFAULT_LOCALE
};

export function DefaultProductCustomization(): any {
    return deepCopy(DefaultProductCustomizationObject);
}

const DefaultSubProductObject: SubProductDTO = {
    attributes: [] as SubProductAttributeDTO[],
    restrictions: [] as RestrictionDTO[],
    subSubProducts: [] as SubProductDTO[]
};

export function DefaultSubProduct(): SubProductDTO {
    return deepCopy(DefaultSubProductObject);
}

const DefaultProductObject: ProductDTO = {
    attachments: [] as DocumentDescriptionDTO[],
    notes: [] as NoteDTO[],
    productPricingOptions: [
        {
            optionPricingCurrency: Currency.EUR,
            optionType: PricingOptionType.FIXED,
            optionKey: 'BUDGET',
            optionName: 'Budget'
        } as ProductPricingOptionDTO
    ],
    subProducts: [],
    attributes: []
};

export function DefaultProduct(): ProductDTO {
    return deepCopy(DefaultProductObject);
}

const DefaultProductPricingOptionObject: ProductPricingOptionDTO = {};

export function DefaultProductPricingOption(): ProductPricingOptionDTO {
    return deepCopy(DefaultProductPricingOptionObject);
}

const DefaultBudgetPricingOptionObject: ProductPricingOptionDTO = {
    //optionType: PricingOptionType.FIXED,
    optionType: 'FIXED',
    optionKey: 'BUDGET',
    optionName: 'Budget'
};

export function DefaultBudgetPricingOption(): ProductPricingOptionDTO {
    return deepCopy(DefaultBudgetPricingOptionObject);
}

const DefaultCompanyObject: CompanyDTO = {
    naceCode: '',
    roles: [] as CompanyRole[],
    attributes: []
};

export const DefaultCompany = (): CompanyDTO => {
    return deepCopy(DefaultCompanyObject);
};

const DefaultEmployeeTransactionObject: EmployeeTransactionEntity = {
    attributes: [
        {
            attributeName: TransactionAttribute.AMOUNT,
            valueType: AttributesValueType.NUMBER
        } as EmployeeTransactionAttributeDTO,
        {
            attributeName: TransactionAttribute.CURRENCY,
            strValue: ['EUR'],
            valueType: AttributesValueType.STRING
        } as EmployeeTransactionAttributeDTO,
        {
            attributeName: TransactionAttribute.DESCRIPTION,
            valueType: AttributesValueType.STRING
        } as EmployeeTransactionAttributeDTO,
        {
            attributeName: TransactionAttribute.GOODWILL_PAYMENT,
            booleanValue: [false],
            valueType: AttributesValueType.BOOL
        } as EmployeeTransactionAttributeDTO
    ] as EmployeeTransactionAttributeDTO[]
};

export function DefaultEmployeeTransaction(): EmployeeTransactionEntity {
    return deepCopy(DefaultEmployeeTransactionObject);
}

const DefaultOfficeObject: OfficeDTO = {
    addresses: [] as AddressDTO[],
    attachments: [] as DocumentDescriptionDTO[],
    notes: [] as NoteDTO[]
};

export function DefaultOffice(): OfficeDTO {
    return deepCopy(DefaultOfficeObject);
}

const DefaultPersonObject: PersonDTO = {
    firstName: '',
    lastName: '',
    addresses: [] as AddressDTO[],
    emails: [] as EmailDTO[],
    phoneNumbers: [] as PhoneNumberDTO[],
    notes: [] as NoteDTO[],
    officeIds: [] as string[]
};

export function DefaultPerson(): PersonDTO {
    return deepCopy(DefaultPersonObject);
}

const DefaultRegistrationPeriodObject: CompanyRegistrationPeriodDTO = {
    companyProductSelectionIds: [],
    effectiveFrom: new Date(),
    registrationPeriodFrom: new Date(),
    attributes: [] as CompanyRegistrationPeriodAttributeDTO[]
};

export function DefaultRegistrationPeriod(): CompanyRegistrationPeriodDTO {
    return deepCopy(DefaultRegistrationPeriodObject);
}

const DefaultEmployeeCaseObject: EmployeeCaseEntity = {
    status: CaseStatusType.CHECKING,
    dateOfClaimStart: new Date(),
    dateOfClaimEnd: new Date()
};

export function DefaultEmployeeCase(): EmployeeCaseEntity {
    return deepCopy(DefaultEmployeeCaseObject);
}

export function deepCopy<T>(source: T): T {
    return cloneDeep(source);

    // if (source === null) {
    //     return source;
    // }
    // if (source instanceof Date) {
    //     return new Date(source.getTime()) as T;
    // }
    // if (Array.isArray(source)) {
    //     return source.map((item) => deepCopy(item)) as T;
    // }

    // if (typeof source === 'object') {
    //     return Object.getOwnPropertyNames(source).reduce((o, prop) => {
    //         Object.defineProperty(o, prop, Object.getOwnPropertyDescriptor(source, prop)!);
    //         o[prop] = deepCopy((source as { [key: string]: any })[prop]);
    //         return o;
    //     }, Object.create(Object.getPrototypeOf(source)));
    // }
    // return source;
}
